import React from "react";
import DiaryBoard from "../../components/diary/DiaryBoard";
import { Navigate, Route, Routes } from "react-router-dom";
import HelpPage from "../instructor/pages/HelpPage";
import Menu from "./ParentMenu";
import Index from "./pages/Index";
import Settings from "./pages/components/Settings";
import AdmissionProfile from "./pages/components/admission/AdmissionProfile";
import SwitchAdmission from "./pages/components/admission/SwitchAdmission";
import SwitchAttendance from "./pages/components/attendance/SwitchAttendance";
import ViewLeaveDetails from "./pages/components/attendance/ViewLeaveDetails";
import CourseBoard from "./pages/components/courseboard";
import StudentSwitchTab from "./pages/components/courseboard/studentSwitchTab";
import ViewFeeDetails from "./pages/components/fee/ViewFeeDetails";
import ParentForm from "./pages/components/form";
import SwitchParentForm from "./pages/components/manageform/SwitchParentForm";
import HomeWorkBroadcast from "./pages/components/message/HomeWorkBroadcast";
import InstructorConverstion from "./pages/components/message/InstructorConverstion";
// import TemplateList from "./pages/components/reportcard/TemplateList";
// import ViewTemplate from "./pages/components/reportcard/ViewTemplate";
import Schedule from "./pages/components/schedule";
import TransportationStatus from "./pages/components/transportation/TransportationStatus";
import SwitchTransportation from "../admin/pages/components/managetransportation/SwitchTransportation";
import ParentSwitchTransportation from "./pages/components/transportation/SwitchTransportation";
// v1 submission-workflow screen, unrouted by the Assignment-V2 redesign
// import ManageAssignment from "./pages/components/manageassignment/ManageAssignment";
import AssignmentList from "./pages/components/assignment-v2/AssignmentList";
import ManageExam from "./pages/components/manageexam/ManageExam";
// import SwitchTransportation from "./pages/components/transportation/SwitchTransportation";
import ParentLiveTracking from "./pages/Live tracking";

import TripConsentList from "./pages/components/trip/TripConsentList";

import TemplateList from "./pages/components/reportcard-V2/TemplateList";
import ViewTemplate from "./pages/components/reportcard-V2/ViewTemplate";

const url = "/dashboard";

const ParentRoutes = () => {
  return (
    <Routes>
      <Route path="parent/menu" element={<Menu />} />
      <Route path="parent/menu/admission" element={<SwitchAdmission />} />
      <Route path="parent/menu/admission/:id" element={<AdmissionProfile />} />
      <Route path="parent/menu/fee" element={<ViewFeeDetails />} />
      <Route path="parent/menu/attendance" element={<SwitchAttendance />} />
      <Route path="parent/menu/student/leave/:id" element={<ViewLeaveDetails />} />
      <Route path="parent/menu/report-card/:id" element={<ViewTemplate />} />
      <Route path="parent/menu/report-card" element={<TemplateList />} />
      <Route path="parent/menu/template/report-card/:id" element={<ViewTemplate />} />
      <Route path="parent/menu/form/" element={<ParentForm />} />
      <Route path="parent/menu/course-board" element={<CourseBoard />} />
      <Route path="parent/:className/:classId/:subjectId" element={<StudentSwitchTab />} />
      <Route path="parent/menu/schedule/" element={<Schedule />} />
      <Route path="parent/menu/manage-form/" element={<SwitchParentForm />} />
      <Route path="parent/menu/consent-form" element={<TripConsentList />} />
      <Route path="parent/help" element={<HelpPage />} />
      <Route path="parent/menu/setting/" element={<Settings />} />
      <Route path="parent/menu/homework/" element={<HomeWorkBroadcast />} />
      <Route path="parent/menu/diary" element={<DiaryBoard role="parent" mode="senior" />} />
      <Route path="parent/menu/message/" element={<InstructorConverstion />} />
      {/* <Route path="parent/menu/transportation/" element={<TransportationStatus />} /> */}

      <Route path="parent/menu/transportation/" element={<ParentSwitchTransportation />} />
      <Route path="parent/menu/live-tracking/" element={<ParentLiveTracking />} />
      <Route path="parent/menu/assignment" element={<AssignmentList />} />
      <Route path="parent/menu/exam/" element={<ManageExam />} />
      <Route path="parent/home" element={<Index />} />
      <Route index element={<Navigate to={`${url}/parent/home`} replace />} />
    </Routes>
  );
};

export default ParentRoutes;
